import { render, staticRenderFns } from "./SeamansBookForm.vue?vue&type=template&id=447947d0&scoped=true"
import script from "./SeamansBookForm.vue?vue&type=script&lang=js"
export * from "./SeamansBookForm.vue?vue&type=script&lang=js"
import style0 from "./SeamansBookForm.vue?vue&type=style&index=0&id=447947d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447947d0",
  null
  
)

export default component.exports